import { Field } from 'formik';
import React from 'react';
import { FormikInputText, FormikInputTextarea } from './input';
import classNames, { Argument } from 'classnames';
import { Size } from '../../shared/types/size';
import { FormikInputSelect } from './select';
import { OptionsType } from 'rc-select/lib/interface';

export interface FormikFieldProps {
    as: string;
    className?: Argument;
    name: string;
    placeholder?: string;
    size?: Size;
    autoGrow?: boolean;
    minRows?: number;
    maxRows?: number;
    prefix?: React.ReactNode;
    disabled?: boolean;
    options?: OptionsType;
    noPadding?: boolean;
    onChange?: (e: React.ChangeEvent<any>) => void;
    onKeyUp?: (e: React.ChangeEvent<any>) => void;
    value?: any;
    wrapClassName?: string;
    type?: string;
    pattern?: string;
}

const FormikField = ({ as, className, wrapClassName, ...props }: FormikFieldProps) => {
    return (
        <div className={`zen-form-item-control ${wrapClassName}`}>
            <div className={`zen-form-item-control-input`}>
                <div className={`zen-form-item-control-input-content`}>
                    {as === 'text' && (
                        <Field
                            component={FormikInputText}
                            className={`zen-input ${classNames(className)}`}
                            {...props}
                        />
                    )}
                    {as === 'textarea' && (
                        <Field
                            component={FormikInputTextarea}
                            className={`zen-input ${classNames(className)}`}
                            {...props}
                        />
                    )}
                    {as === 'select' && (
                        <Field
                            component={FormikInputSelect}
                            className={`zen-input ${classNames(className)}`}
                            {...props}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default FormikField;
